var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLandingPad = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#9FADC5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.523 10.995c-12.85.006-23.262 10.426-23.258 23.276.004 12.849 10.422 23.263 23.272 23.261 12.85-.002 23.265-10.419 23.265-23.268-.015-12.85-10.43-23.26-23.28-23.269zm9.883 34.215h-5.658a25.76 25.76 0 00.21-3.888V36.21h-8.87v5.106c-.024 1.3.046 2.6.21 3.888H24.64c.17-1.288.24-2.588.21-3.888v-14.1c.028-1.3-.042-2.6-.21-3.888h5.658c-.16 1.29-.23 2.589-.21 3.888v4.37h8.87v-4.37c.03-1.3-.04-2.6-.21-3.888h5.658a25.015 25.015 0 00-.21 3.888v14.1a27.97 27.97 0 00.21 3.896v-.002z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.523 0a34.264 34.264 0 1034.26 34.264C68.784 15.34 53.446 0 34.524 0zm0 59.875C20.386 59.87 8.93 48.407 8.932 34.271 8.934 20.134 20.393 8.675 34.53 8.673c14.136-.002 25.599 11.454 25.604 25.59-.01 14.141-11.47 25.602-25.611 25.612z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLandingPad, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/landing-pad.633726e4.svg";
export { ForwardRef as ReactComponent };